import {USER_PROFILE} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/phone'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {changePhone as text} from '../../profile/text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class changePhone {

  static setNumber(number) {
    return {
      type: types.SET_NUMBER,
      payload: {
        value: number,
      },
    }
  }

  static setCountryCode(number) {
    return {
      type: types.SET_COUNTRY_CODE,
      payload: {
        value: number,
      },
    }
  }

  static sendCode() {
    return function(dispatch, getState) {

      const state = getState().ui.rentV2.phone
      const number = state.get('number')
      const countryCode = state.get('countryCode')

      if (number === '' || countryCode === '') {
        dispatch(changePhone.sendCodeFail('Complete todos los campos'))
        return
      }

      dispatch({type: types.SEND_CODE})

      let formatlessNumber = number.toString()
      formatlessNumber = formatlessNumber.replace(/\(/g, '')
      formatlessNumber = formatlessNumber.replace(/\)/g, '')
      formatlessNumber = formatlessNumber.replace(/-/g, '')
      formatlessNumber = formatlessNumber.replace(/ /g, '')

      const data = new FormData()
      data.append('phone_number', '+' + countryCode.toString() + formatlessNumber)

      apiPrivate.post(USER_PROFILE + '/user/phone/verificationSMS', data)
        .then(response => {
          dispatch(changePhone.sendCodeSuccess())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(changePhone.sendCodeFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(changePhone.sendCodeFail(message))
        })
    }
  }

  static sendCodeSuccess() {
    return {
      type: types.SEND_CODE_SUCCESS,
    }
  }

  static sendCodeFail(error) {
    return {
      type: types.SEND_CODE_FAIL,
      payload: {
        error,
      },
    }
  }

  static setOpenDialog(show) {
    return {
      type: types.SET_OPEN_DIALOG,
      payload: {
        show,
      },
    }
  }

  static setCode(code) {
    return {
      type: types.SET_CODE,
      payload: {
        value: code,
      },
    }
  }

  static save() {
    return function(dispatch, getState) {

      const state = getState().ui.rentV2.phone
      const number = state.get('number')
      const countryCode = state.get('countryCode')
      const code = state.get('code')

      if (code === '' || number === '' || countryCode === '') {
        dispatch(changePhone.saveFail('Complete todos los campos'))
        return Promise.resolve(false)
      }

      dispatch({type: types.SAVE})

      const data = new FormData()
      data.append('phone_number', '+' + countryCode.toString() + number.toString())
      data.append('code', code)

      return apiPrivate.post(USER_PROFILE + '/user/phone', data)
        .then(response => {
          dispatch(changePhone.saveSuccess())
          dispatch(simpleSnackbarActions.showMessage(text.phoneChangeSuccess))
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(changePhone.saveFail(message))
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(changePhone.saveFail(message))
          return false
        })
    }
  }

  static saveSuccess() {
    return {
      type: types.SAVE_SUCCESS,
    }
  }

  static saveFail(error) {
    return {
      type: types.SAVE_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/rentV2/actions/phone.js